import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, User } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    setIsLoggedIn(!!token);
    setIsAdmin(user.role === 'admin');
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0f172a]/95 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <video 
              src="/images/bo7-lobby-gif.webm"
              autoPlay loop muted playsInline
              className="w-12 h-12 rounded-full"
            />
            <span className="text-xl font-black uppercase tracking-wider font-['Unbounded']">AFK BOOSTS</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" data-testid="nav-home" className="text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors">
              Home
            </Link>
            <Link to="/apex" data-testid="nav-apex" className="text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors">
              Apex Legends
            </Link>
            <Link to="/blackops" data-testid="nav-blackops" className="text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors">
              Black Ops 7
            </Link>
            <Link to="/titan" data-testid="nav-titan" className="text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors">
              Titan
            </Link>
            <a 
              href="https://discord.gg/afkrev" 
              target="_blank" 
              rel="noopener noreferrer"
              data-testid="nav-discord"
              className="text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors"
            >
              Discord
            </a>
            {isAdmin && (
              <Link 
                to="/admin"
                data-testid="nav-admin"
                className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-6 uppercase tracking-wider text-sm transition-all flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V3zm3 3a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm0 3a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm0 3a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
                ADMIN
              </Link>
            )}
            {isLoggedIn ? (
              <Link 
                to="/portal"
                data-testid="nav-portal"
                className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 uppercase tracking-wider text-sm transition-all flex items-center gap-2"
              >
                <User size={18} />
                PORTAL
              </Link>
            ) : (
              <Link 
                to="/login"
                data-testid="nav-login"
                className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 uppercase tracking-wider text-sm transition-all"
              >
                LOGIN
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden py-6 space-y-4 border-t border-white/10" data-testid="mobile-menu">
            <Link 
              to="/" 
              onClick={() => setIsOpen(false)}
              className="block text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors"
            >
              Home
            </Link>
            <Link 
              to="/apex" 
              onClick={() => setIsOpen(false)}
              className="block text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors"
            >
              Apex Legends
            </Link>
            <Link 
              to="/blackops" 
              onClick={() => setIsOpen(false)}
              className="block text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors"
            >
              Black Ops 7
            </Link>
            <Link 
              to="/titan" 
              onClick={() => setIsOpen(false)}
              className="block text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors"
            >
              Titan
            </Link>
            <a 
              href="https://discord.gg/afkrev" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block text-gray-300 hover:text-red-500 uppercase tracking-wider font-['Rajdhani'] font-semibold transition-colors"
            >
              Discord
            </a>
            {isAdmin && (
              <Link 
                to="/admin"
                onClick={() => setIsOpen(false)}
                className="block bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-6 uppercase tracking-wider text-sm transition-all text-center"
              >
                ADMIN DASHBOARD
              </Link>
            )}
            {isLoggedIn ? (
              <Link 
                to="/portal"
                onClick={() => setIsOpen(false)}
                className="block bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 uppercase tracking-wider text-sm transition-all text-center"
              >
                PORTAL
              </Link>
            ) : (
              <Link 
                to="/login"
                onClick={() => setIsOpen(false)}
                className="block bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 uppercase tracking-wider text-sm transition-all text-center"
              >
                LOGIN
              </Link>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;